var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[(_vm.entry.embedArticle)?_c('ArticleCardEmbed',{attrs:{"article":_vm.entry.embedArticle,"data-layer":{ name: "Haber Detay - Önerilen İçerikler", position: 1 }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }